<!-- <div
  *ngIf="!gwp"
  class="motivator flex-shrink-1 d-flex flex-column align-items-center"
>
  Add
  {{ 4 - totalQty }}
  more item{{ 4 - totalQty == 1 ? "" : "s" }} to get 15% off your order
  <div class="progress w-100">
    <div
      class="progress-bar"
      role="progressbar"
      aria-valuenow="25"
      aria-valuemin="0"
      aria-valuemax="100"
      [style.width]="(totalQty / 4) * 100 + '%'"
    ></div>
  </div>
</div> -->
<div
  *ngIf="gwp"
  class="motivator flex-shrink-1 d-flex flex-column align-items-center"
>
  Free Gift Applied {{ gwp?.merchandise?.product?.title }}!
</div>
